export const API_BASE_URL = 'https://kehilaapi.syn-assist.fr'
export const API_PROD_BASE_URL = 'https://api.kehila.syn-assist.fr'
export const WEB_DEV_BASE_URL = 'http://localhost:4000'
export const WEB_PROD_BASE_URL = 'https://kehila.io'
export const CAMPAGNE_PROD_BASE_URL = 'https://charithon.io'
